import type { EngineUseStatus } from "@shared-core/data/manufacturing-setup-types";
import {
  engineUseLabel,
  engineUseSymbol,
  engineUseTone,
} from "@shared-core/domain/manufacturing-setup-presentation";
import { Badge } from "../../primitives/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../../primitives/tooltip";

/**
 * "● used by engine" / "○ replicated, not used" / "◌ not yet replicated" —
 * the field-provenance badge every Manufacturing setup page shows (design
 * note `docs/features/cost-engine-productionisation/03_manufacturing_surfaces_design.md`).
 * Reuses the app's existing, already-contrast-checked Badge variants
 * (success/neutral/outline) rather than any new colour — see
 * `manufacturing-setup-presentation.ts` for why.
 */
export function EngineUseBadge({
  status,
  why,
}: {
  status: EngineUseStatus;
  why?: string | null;
}) {
  const badge = (
    <Badge
      variant={engineUseTone(status)}
      className={why ? "cursor-help" : undefined}
    >
      {engineUseSymbol(status)} {engineUseLabel(status)}
    </Badge>
  );
  if (!why) return badge;
  return (
    <Tooltip>
      <TooltipTrigger asChild>{badge}</TooltipTrigger>
      <TooltipContent className="max-w-xs">{why}</TooltipContent>
    </Tooltip>
  );
}
